import React, { useEffect } from 'react'
import { Route, Routes, useParams } from 'react-router-dom'

import { withUserStore } from '../../contexts/UserStore'
import Dashboard from './Dashboard'
import Priorities from './Priorities'
import Strategies from './Strategies'
import Goals from './Goals'
import Tasks from './Tasks'
import AccountContainer from './Account/Container'
import PageWrapper from '../Shared/PageWrapper'
import Help from './Help'
import { withModals } from '../../contexts/modals'

const PrioritizePlusContainer = ({ userStore }) => {
  const { accountId } = useParams()
  const getAccount = () => userStore.account
  useEffect(() => {
    userStore.setAccountId(parseInt(accountId))
  }, [accountId])

  return (
    <Routes>
      <Route path="/" element={<PageWrapper name="Dashboard"><Dashboard account={getAccount(accountId)} /></PageWrapper>} />
      <Route path="priorities" element={<PageWrapper name="Priorities"><Priorities account={getAccount(accountId)} /></PageWrapper>} />
      <Route path="priority/:priorityId" element={<PageWrapper name="Priorities"><Priorities account={getAccount(accountId)} /></PageWrapper>} />
      <Route path="strategies" element={<PageWrapper name="Strategies"><Strategies account={getAccount(accountId)} /></PageWrapper>} />
      <Route path="strategy/:strategyId" element={<PageWrapper name="Strategies"><Strategies account={getAccount(accountId)} /></PageWrapper>} />
      <Route path="priority/:priorityId/strategies" element={<PageWrapper name="Strategies"><Strategies account={getAccount(accountId)} /></PageWrapper>} />
      <Route path="priority/:priorityId/goals" element={<PageWrapper name="Goals"><Goals account={getAccount(accountId)} /></PageWrapper>} />
      <Route path="goals" element={<PageWrapper name="Goals"><Goals account={getAccount(accountId)} /></PageWrapper>} />
      <Route path="goals/:goalId" element={<PageWrapper name="Goals"><Goals account={getAccount(accountId)} /></PageWrapper>} />
      <Route path="strategy/:strategyId/goals" element={<PageWrapper name="Goals"><Goals account={getAccount(accountId)} /></PageWrapper>} />
      <Route path="tasks" element={<PageWrapper name="Tasks"><Tasks account={getAccount(accountId)} /></PageWrapper>} />
      <Route path="goal/:goalId/tasks" element={<PageWrapper name="Tasks"><Tasks account={getAccount(accountId)} /></PageWrapper>} />
      <Route path="help" element={<PageWrapper name="Help"><Help account={getAccount(accountId)} /></PageWrapper>} />
      <Route path="organization/*" element={<PageWrapper name="Account"><AccountContainer account={getAccount(accountId)} /></PageWrapper>} />
    </Routes>
  )
}

export default withUserStore(withModals(PrioritizePlusContainer))
